/* -------------------------------------------------------------------------- */
/*                             Botón para cancelar                            */
/* -------------------------------------------------------------------------- */
export const cancelButton = {
  backgroundColor: "#f44336",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#d32f2f",
  },
};

/* -------------------------------------------------------------------------- */
/*                             Botón para guardar                            */
/* -------------------------------------------------------------------------- */
export const saveButton = {
  backgroundColor: "#4caf50",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#388e3c",
  },
};

/* -------------------------------------------------------------------------- */
/*                             Botón para aprobar                            */
/* -------------------------------------------------------------------------- */
export const approveButton = {
  backgroundColor: "#2b45b8",
  color: "#fff",
  "&:hover": {
    backgroundColor: "#1a237e",
  },
};

/* -------------------------------------------------------------------------- */
/*                            Celda para más filas                            */
/* -------------------------------------------------------------------------- */
export const moreCell = {
  width: "50%",
  whiteSpace: "normal",
  wordBreak: "break-word",
  verticalAlign: "top",
  textAlign: "left",
};

/* -------------------------------------------------------------------------- */
/*                                Footer action                               */
/* -------------------------------------------------------------------------- */
export const footerButton = (theme) => ({
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(1),
});
